'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _glob = require('glob');

var _glob2 = _interopRequireDefault(_glob);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const globs = {
  camelCaseFile: '[A-Z]*.{js,ts}',
  camelCaseDir: '[A-Z]*/{index,[A-Z]*}.{js,ts}',
  jsxFile: '*.{jsx,tsx}'
};

/**
 * List react component files inside a directory
 */

const listReactFiles = cwd => {
  const patterns = Object.keys(globs).map(key => globs[key]);
  const pattern = `**/{${patterns.join(',')}}`;
  const ignore = ['**/node_modules/**', '**/{__tests__,test,tests}/**', '**/*.{test,spec}.*'];

  return new Promise((resolve, reject) => {
    (0, _glob2.default)(pattern, { cwd, ignore }, (err, files) => {
      // istanbul ignore next
      if (err) {
        reject(err);
      }
      resolve(files);
    });
  });
};

exports.default = listReactFiles;